export const API_ENDPOINT =
  window.location.hostname === 'localhost'
    ? 'http://localhost:3005'
    : 'https://portal.ascendtms.com/api';
